<kendo-menu [items]="items" (select)="onSelect($event)">
  <ng-template kendoMenuItemLinkTemplate let-item="item" let-index="index">
    <span [kendoMenuItemLink]="index" class="menu-item-size">
      {{ item.text }}
      <div *ngIf="item.items && item.items.length" class="k-icon k-i-arrow-chevron-down primary-color small-padding">
      </div>
    </span>
  </ng-template>
</kendo-menu>
